const columnDataSurveys = [
  {
    dataField: 'surveyNumId',
    caption: 'Номер опроса',
    dataType: 'number',
    notVisible: false,
    allowSearch: false,
    allowFiltering: false
  },
  {
    dataField: 'dateFrom',
    caption: 'Дата начала опроса',
    dataType: 'date',
    notVisible: false,
    allowSearch: false,
    allowFiltering: false
  },
  {
    dataField: 'dateTo',
    caption: 'Дата окончания опроса',
    dataType: 'date',
    notVisible: false,
    allowSearch: false,
    allowFiltering: false
  },
  {
    dataField: 'title',
    caption: 'Заголовок опроса',
    dataType: 'string',
    notVisible: false,
    allowSearch: false,
    allowFiltering: false
  },
  {
    dataField: 'isActiveFlag',
    caption: 'Активность опроса',
    dataType: 'boolean',
    notVisible: false,
    allowSearch: false,
    allowFiltering: false
  }
];

export default columnDataSurveys;
